import { ComposedTheme, createUseStyles } from '@glu/theming';
import { ITypographyProps } from './Typography';

type TStyleProps = Pick<ITypographyProps, 'textAlign'>;

export default createUseStyles(({ typography }: ComposedTheme) => ({
  accessibility: {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    border: 0,
  },
  common: {
    textAlign: ({ textAlign }: TStyleProps) => textAlign,
  },
  noWrap: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  h1: typography.h1,
  h2: typography.h2,
  h3: typography.h3,
  h4: typography.h4,
  h5: typography.h5,
  paragraph: typography.text,
  'small-text': typography.smallText,
  'xtra-small-text': typography.xtraSmallText,
  'tiny-text': typography.tinyText,
}));
